var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"planOrFee"},[(_vm.user.isLogged)?_c('div',{staticClass:"planOrFee_userRegister"},[_c('AccountDetails',{on:{"account-details:continue":_vm.isCotinueIsLogged}})],1):_c('div',{staticClass:"planOrFee_accountDetails"},[_c('AccountNotLoggedIn')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }